module.exports = __webpack_public_path__ + "static/img/bx3.ff92749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bx3.png
// module id = UNr2
// module chunks = 0